import type { OnboardingGlobe } from "#onboarding-globe-types";
import onboardingGlobeData from "#onboarding-globe.gen.json" with { type: "json" };

/** The onboarding's globe: coastlines, and the Learn map's mainland (see `_build-onboarding-globe.ts`). */
export const ONBOARDING_GLOBE: OnboardingGlobe = onboardingGlobeData;
